/* src/app/admin/power-bi/power-bi-report/power-bi-report.component.scss */
.tab-buttons {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
  margin-top: 10px;
  gap: 10px;
}
.tab-buttons button {
  padding: 8px 14px;
  background-color: #eee;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}
.tab-buttons button.active {
  background-color: #0066cc;
  color: white;
}
.tab-buttons button:hover {
  background-color: #ddd;
}
/*# sourceMappingURL=power-bi-report.component-7JKBDIFU.css.map */
